import { defineAction } from '../utils/defineAction';

const INIT = 'INIT';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';

const httpActions = [INIT, SUCCESS, ERROR];

export const HPS_ENROLL = defineAction(
  'HPS_ENROLL',
  ['CHANGE_STEP', 'UPDATE_PATIENT_INFO', 'CLEAR'],
);

export const SUBMIT_HPS_ENROLL_FORM = defineAction(
  'SUBMIT_HPS_ENROLL_FORM',
  httpActions,
);
